(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds-switch.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds-switch.js');

(function(Backbone, _, svs, $) {
  svs.matchen.views.MatchenOddsSwitch = Marionette.View.extend({
    template: function(data) {
      return svs.matchen.templates.matchen_odds_switch(data);
    },
    ui: {
      oddsSwitch: '.js-odds-switch'
    },
    events: {
      'change @ui.oddsSwitch': 'toggleOddsView'
    },
    initialize: function() {
      var self = this;

      svs.components.Storage.browser.get('oddsType', 'matchen', function(data) {
        if (typeof data !== 'undefined') {
          self.trigger('changeOddsView', data);
          $('input.js-odds-switch').prop('checked', false);
          $("input.js-odds-switch[value='" + data + "']").prop('checked', true);
        }
      });
    },
    toggleOddsView: function(e) {
      svs.components.Storage.browser.get('oddsType', 'matchen', function() {
        if (e.target.value === 'my-odds') {
          svs.components.Storage.browser.set('oddsType', 'matchen', 'my-odds');
        } else if (e.target.value === 'least-most') {
          svs.components.Storage.browser.set(
            'oddsType',
            'matchen',
            'least-most'
          );
        }
      });

      this.trigger('changeOddsView', e.target.value);
    }
  });
})(Backbone, _, svs, $);


 })(window);